import { useEffect } from 'react';

function applyVisualViewport() {
  const viewport = window.visualViewport;
  const height = Math.round(viewport?.height || window.innerHeight);
  const offsetTop = Math.round(viewport?.offsetTop || 0);
  const keyboardOpen = window.innerHeight - height > 80;
  const root = document.documentElement;
  root.style.setProperty('--app-vh', `${height}px`);
  root.style.setProperty('--app-vv-top', `${offsetTop}px`);
  root.classList.toggle('app-keyboard-open', keyboardOpen);
}

export function useVisualViewportLock() {
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    applyVisualViewport();
    root.classList.add('app-vv-lock');
    body.classList.add('app-vv-lock');

    const viewport = window.visualViewport;
    viewport?.addEventListener('resize', applyVisualViewport);
    viewport?.addEventListener('scroll', applyVisualViewport);
    window.addEventListener('orientationchange', applyVisualViewport);
    window.addEventListener('resize', applyVisualViewport);

    return () => {
      root.classList.remove('app-vv-lock', 'app-keyboard-open');
      body.classList.remove('app-vv-lock');
      root.style.removeProperty('--app-vh');
      root.style.removeProperty('--app-vv-top');
      viewport?.removeEventListener('resize', applyVisualViewport);
      viewport?.removeEventListener('scroll', applyVisualViewport);
      window.removeEventListener('orientationchange', applyVisualViewport);
      window.removeEventListener('resize', applyVisualViewport);
    };
  }, []);
}
